/**
 * Mock systém - hlavný export
 *
 * Použitie:
 * 1. Pre zapnutie mock režimu nastaviť v src/mock/config.js:
 *    useMockData: true
 *
 * 2. Alebo cez localStorage:
 *    localStorage.setItem('useMockData', 'true')
 *
 * 3. Alebo cez window objekt (runtime):
 *    window.mockConfig.useMockData = true
 */

// Konfigurácia
export {
  default as mockConfig,
  setMockConfig,
  isMockEnabled,
  isMocked,
  mockDelay,
} from "./config";

// Mock fetch handler
export { default as mockFetch } from "./mockFetch";

// Dáta - Officials
export {
  officials,
  ovmIds,
  countryIds,
  municipalityIds,
} from "./data/officials";

// Dáta - OVMs
export { ovms, ovmsNoOfficials } from "./data/ovms";

// Dáta - Legitimates
export { legitimates } from "./data/legitimates";

// Dáta - Requests
export { requests, requestsPublic } from "./data/requests";

// Dáta - Initiatives
export { initiatives, initiativesPublic } from "./data/initiatives";

// Dáta - Statements
export {
  statements,
  statementsPublic,
  statementsGrid,
  STATEMENT_TYPES,
  STATEMENT_STATES,
} from "./data/statements";

// Dáta - Financial Institutions
export { financialInstitutions } from "./data/financialInstitutions";

// Dáta - Dictionaries
export { dictionaries } from "./data/dictionary";

// Dáta - Statistics
export { statistics } from "./data/statistics";

// Dáta - Internal Users
export { internalUsers } from "./data/internalUsers";

// Dáta - Who Looked (Nahlizeni)
export { whoLooked } from "./data/whoLooked";

// Dáta - Profiles
export { profiles, getProfileByRole } from "./data/profile";

// Pomocné funkcie pre testovanie
export const mockHelpers = {
  // Resetuje konfiguráciu na default
  resetConfig: () => {
    localStorage.removeItem("useMockData");
    localStorage.removeItem("mockDelay");
    localStorage.removeItem("mockUserRole");
  },

  // Zapne mock režim
  enableMock: () => {
    localStorage.setItem("useMockData", "true");
    console.log("[MOCK] Mock režim zapnutý. Refreshnite stránku.");
  },

  // Vypne mock režim
  disableMock: () => {
    localStorage.setItem("useMockData", "false");
    console.log("[MOCK] Mock režim vypnutý. Refreshnite stránku.");
  },

  // Nastaví oneskorenie
  setDelay: (ms) => {
    localStorage.setItem("mockDelay", String(ms));
    console.log(`[MOCK] Oneskorenie nastavené na ${ms}ms.`);
  },

  // Nastaví rolu používateľa
  setUserRole: (role) => {
    const validRoles = ["admin", "eo", "tajemnik", "vf", "public"];
    if (validRoles.includes(role)) {
      localStorage.setItem("mockUserRole", role);
      console.log(`[MOCK] Rola nastavená na: ${role}. Refreshnite stránku.`);
    } else {
      console.error(`[MOCK] Neplatná rola. Použite: ${validRoles.join(", ")}`);
    }
  },

  // Zobrazí aktuálny stav
  status: () => {
    console.log("[MOCK] Status:");
    console.log("  - useMockData:", localStorage.getItem("useMockData"));
    console.log("  - mockDelay:", localStorage.getItem("mockDelay"));
    console.log("  - mockUserRole:", localStorage.getItem("mockUserRole"));
  },
};

// Globálne sprístupnenie pre debugovanie
if (typeof window !== "undefined") {
  window.mockHelpers = mockHelpers;
  console.log(
    "[MOCK] Mock helpers dostupné cez window.mockHelpers (enableMock, disableMock, setDelay, setUserRole, status)",
  );
}
